// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_8b3a0b', '__Inter_Fallback_8b3a0b'","fontStyle":"normal"},"className":"__className_8b3a0b","variable":"__variable_8b3a0b"};